import { dueDateServices } from 'src/services/reservation/due-date/dueDate.service'

export const createDueDateMethodByBusinessUnit = async (due_date_method, business_unit_id) => {
  const dueDateMethodToCreate = due_date_method.filter(
    (elem) => elem?.due_date_method_id && elem?.new_register
  )
  if (dueDateMethodToCreate.length > 0) {
    try {
      const promises = dueDateMethodToCreate.flatMap((elem) => {
        return elem.product_id.map(async (product_id) => {
          const elemCopy = { ...elem } // Copiamos el elemento para no mutar el original
          elemCopy.business_unit_id = business_unit_id
          elemCopy.product_id = product_id
          delete elemCopy.new_register
          const response = await dueDateServices.createDueDateMethodByBusinessUnit(elemCopy)
          return response
        })
      })

      const results = await Promise.all(promises)
      return results
    } catch (error) {
      return false
    }
  }
  return true
}
